import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IAdmin } from "@app/core/models/IAdmin";
import { Api } from "@app/shared/config/Api";
import { IApiResponse } from "@app/shared/models/iApiResponse.model";
import { ErrorService } from "@app/shared/services/error/error.service";
import { catchError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  constructor(private http: HttpClient, private errorService: ErrorService) {}

  api = new Api();

  getUserById(id: string) {
    return this.http
      .get<IAdmin>(`${this.api.getHostV1()}/admin/${id}/`)
      .pipe(catchError(this.errorService.handleError));
  }

  getUsers() {
    return this.http.get<IAdmin[]>(`${this.api.getHostV1()}/admin/`);
  }

  registerUser(data: Partial<IAdmin>) {
    return this.http
      .post<Partial<IAdmin>>(`${this.api.getHostV1()}/admin/`, data)
      .pipe(catchError(this.errorService.handleError));
  }

  updateUser(id: string, data: Partial<IAdmin>) {
    return this.http
      .put<Partial<IAdmin>>(`${this.api.getHostV1()}/admin/${id}/`, data)
      .pipe(catchError(this.errorService.handleError));
  }

  deleteUser(id: string) {
    return this.http
      .delete<IApiResponse>(`${this.api.getHostV1()}/admin/${id}/`)
      .pipe(catchError(this.errorService.handleError));
  }
}
